import React, {Component} from 'react';
import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	Link,
	Row,
	Col
} from 'reactstrap';
import classnames from 'classnames';
import ResultadoExpandidoErros from './ResultadoExpandidoErros';
import '../../_Content/css/eco-template.css';
import '../../_Content/css/resultado.css';
import "react-table/react-table.css";
import {ReactTableDefaults} from "react-table";

Object.assign(ReactTableDefaults, {
	nextText: 'Proxíma',
	previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pag.',
	ofText: 'de'
});

class ResultadoExpandido extends Component {

	constructor(props) {
		super(props);
		this.state = {lista: []};
		this.toggle = this.toggle.bind(this);
		this.state = {
			activeTab: '1'
		};
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	verificaSugestaoVazia = (val) => {

        if (val == "mensagem" && this.props.mensagem) {
            return (
                <Row>
                    <Col sm="12">
                        <div className="text-descricao-expandido">
                            {this.props.mensagem}
                        </div>
                    </Col>
                </Row>
            )
        }
		if (val == "sugestao" && this.props.sugestao) {
			return (
				<Row>
					<Col sm="12">
						<div className="text-descricao-expandido">
							{this.props.sugestao}
						</div>
					</Col>
				</Row>
			)
		}

		if (val == "legislacao" && this.props.legislacao) {
			return (
				<Row>
					<Col sm="12">
						<div className="text-descricao-expandido">
							{this.props.legislacao}
						</div>
					</Col>
				</Row>
			)
		}

		if (val == "particularidades" && this.props.particularidades) {
			return (
				<Row>
					<Col sm="12">
						<div className="text-descricao-expandido">
							{this.props.particularidades}
						</div>
					</Col>
				</Row>
			)
		}
	}

	render() {

		return (
			<div className="div-expandido-resultado" style={{backgroundColor: this.props.color, overflow: 'hidden'}}>
				<Nav tabs className="tabs-expandido-resultado">
					{this.props.mensagem &&
					<NavItem className={classnames({active: this.state.activeTab === '1'})}>
						<NavLink
							onClick={() => {
								this.toggle('1');
							}}>
								<span>Mensagem</span>
						</NavLink>
					</NavItem>
					}
					{ this.props.legislacao &&
						<NavItem className={classnames({active: this.state.activeTab === '2'})}>
							<NavLink
								onClick={() => {
									this.toggle('2');
								}}>
									<span>Legislação</span>
							</NavLink>
						</NavItem>
					}
					{ this.props.sugestao &&
						<NavItem className={classnames({active: this.state.activeTab === '3'}) + " icosugestao"}>
							<NavLink
								onClick={() => {
									this.toggle('3');
								}}>
									<i className="ecoico ecoico-sugestao-econet"/>
									<span>Sugestão ECONET</span>
							</NavLink>
						</NavItem>
                    }
                    {this.props.particularidades &&
                        <NavItem className={classnames({ active: this.state.activeTab === '4' })}>
                            <NavLink
                                onClick={() => {
                                    this.toggle('4');
                                }}>
                                <span>Particularidades</span>
                            </NavLink>
                        </NavItem>
                    }
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
					<TabPane tabId="1">
						<Row>
							<Col sm="12">
								<div className="text-descricao-expandido" dangerouslySetInnerHTML={{ __html: this.props.mensagem ? this.props.mensagem : "Sem dados" }} />
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId="2">
						<Row>
							<Col sm="12">
								<div className="text-descricao-expandido" dangerouslySetInnerHTML={{ __html: this.props.legislacao ? this.props.legislacao : "Sem dados"}}/>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId="3">
						<Row>
							<Col sm="12">
								<div className="text-descricao-expandido" dangerouslySetInnerHTML={{ __html: this.props.sugestao ? this.props.sugestao : "Nenhuma sugestão cadastrada"}}/>
							</Col>
						</Row>
					</TabPane>
                <TabPane tabId="4">
                    <Row>
                        <Col sm="12">
                            <div className="text-descricao-expandido" dangerouslySetInnerHTML={{ __html: this.props.particularidades ? this.props.particularidades : "Sem dados" }} />
                        </Col>
                    </Row>
                    </TabPane>
                </TabContent>
				<Row>
					<Col md={12}>
						<ResultadoExpandidoErros
							id_arquivo={this.props.id_arquivo}
							registro={this.props.registro}
							campo={this.props.campo}
							ocorrencia={this.props.ocorrencia}
							quantidadeErros={this.props.quantidadeErros}
							moduloEfd={this.props.moduloEfd} 
							numNotaFiscal={this.props.numNotaFiscal} />
					</Col>
				</Row>
			</div>
		);
	}
}

export default ResultadoExpandido;


// WEBPACK FOOTER //
// ./src/Componente/Resultado/ResultadoExpandido.jsx